import jwt_decode from "jwt-decode";
import {
  privSponsorKey,
  privTokenKey,
  privBalanceKey,
  headerKeysAllowed,
  privMemberId,
  privIsValidToken,
  TOKEN_VALIDATE,
  CUSTOMER_LITE,
} from "../utils";

// Auth wizard to find the sponsor that is calling
export const solveProvidedKeyToMatch = () => {
  const params = new URLSearchParams(window.location.search);
  const allowedValues = Object.values(headerKeysAllowed);
  let received = [];
  for (const key of params.keys()) {
    const value = params.get(key);
    if (allowedValues.includes(key) && value && value.length > 1) {
      received.push(key);
    }
  }
  // TODO: Workflow for a security issue
  if (received.length !== 1) return null;
  const headerKey = received[0];
  const headerValue = params.get(headerKey);
  // Store the current key to call apis
  localStorage.setItem(privSponsorKey, headerKey);
  localStorage.setItem(privTokenKey, headerValue);
  return headerValue ? headerValue : null;
};

export const authUserOxxo = async (
  token,
  res = { validToken: false, member: null }
) => {
  const valid = await validateTokenOxxo(token);
  localStorage.setItem(privIsValidToken, valid);
  if (!valid) return res;
  const memberId = jwt_decode(token).member_id;
  const member = await retrieveMember(memberId, token, headerKeysAllowed.oxxo);
  if (!member) return res;
  res.validToken = valid;
  res.member = member;
  return res;
};

const validateTokenOxxo = async (token, res = false) => {
  const headers = { Authorization: `Bearer ${token}` };
  const reqOpts = { method: "GET", headers };
  const response = await fetch(TOKEN_VALIDATE, reqOpts);
  const allowedStatus = [200, 204];
  if (response.ok || allowedStatus.includes(response.status)) res = true;
  return res;
};

export const authUserSpin = async (
  token,
  res = { validToken: false, member: null }
) => {
  const { valid, memberId } = await validateTokenSpin(token);
  localStorage.setItem(privIsValidToken, valid);
  if (!valid) return res;
  const member = await retrieveMember(memberId, token, headerKeysAllowed.spin);
  if (!member) return res;
  res.validToken = valid;
  res.member = member;
  return res;
};

const validateTokenSpin = async (
  token,
  res = { valid: false, memberId: null }
) => {
  const headers = { Authorization: `Bearer ${token}` };
  const reqOpts = { method: "POST", headers };
  const response = await fetch(TOKEN_VALIDATE, reqOpts);
  const allowedStatus = [200];
  if (response.ok || allowedStatus.includes(response.status)) {
    res.valid = true;
    const responseJson = await response.json();
    res.memberId = responseJson.gravty_id;
  }
  return res;
};

const retrieveMember = async (memberId, token, header, res = null) => {
  if (!memberId) return res;
  const url = `${CUSTOMER_LITE}/${memberId}`;
  let headers = {};
  if (header === headerKeysAllowed.oxxo) {
    headers.Authorization = `Bearer ${token}`;
  } else if (header === headerKeysAllowed.spin) {
    headers.SpinAuthorization = token;
  }
  const reqOpts = { method: "GET", headers };
  const response = await fetch(url, reqOpts);
  if (response.ok) res = await response.json();
  localStorage.setItem(privBalanceKey, res.balance);
  localStorage.setItem(privMemberId, memberId);
  return res;
};
